module.exports = __webpack_public_path__ + "files/4c10724526eea3a80585fd8b6b62a71f.svg";